<form class="radio-button-group-wrapper" [formGroup]="form">
	<div class="form-row">
		<div class="answer-part">
			<nb-radio-group [id]="getRadioGroupName()" [name]="getRadioGroupName()"
							[formControlName]="fullControlName()" [attr.formcontrolname]="fullControlName()" [status]="isInvalid() ? 'danger' : 'primary'" [disabled]="shouldDisableRadio(controlName)"
							(valueChange)="updateFormControl($event)"
							[attr.data-test-id]="dataTestId">
				<nb-radio id="{{getRadioGroupName()}}-true" name="yes" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
				<nb-radio id="{{getRadioGroupName()}}-false" name="no" [value]="false">{{ 'common.no' | translate }}</nb-radio>
			</nb-radio-group>
			@if (isInvalid()) {
				<div class="validation-message">{{ 'validations.required' | translate }}</div>
			}
		</div>
		<div class="question">{{ question }}</div>
	</div>
</form>
